var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoyaltyactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4013",
    "data-name": "Rectangle 4013",
    width: 24,
    height: 24,
    transform: "translate(-11067 -3043)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loyalty_Program_1",
    "data-name": "Loyalty Program 1",
    transform: "translate(11067 3043)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown",
    transform: "translate(-11065.977 -3044.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8264",
    "data-name": "Path 8264",
    d: "M19.345,11.114,17.8,17.951a.629.629,0,0,1-.629.5H5.117a.629.629,0,0,1-.629-.5l-1.5-6.837a.629.629,0,0,1,.893-.7L7.558,12.2,10.6,6.812a.629.629,0,0,1,1.094,0l3.044,5.39,3.7-1.793a.629.629,0,0,1,.906.7Z",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_819",
    "data-name": "Line 819",
    x2: 13,
    transform: "translate(-11061.5 -3023.5)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyactive);
export default __webpack_public_path__ + "static/media/loyaltyactive.03c7a2892360f56cd53f6b4a8fdc9ea2.svg";
export { ForwardRef as ReactComponent };